export default __webpack_public_path__ + "static/media/right_nav.b565072b.svg";